export default __webpack_public_path__ + "static/dd-design-ac73c57c845de36d81fe09e43032ea6c.jpg";